import { HttpErrorResponse, HttpClient } from '@angular/common/http';
import {ChangeDetectorRef, Component, HostListener, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Subject, Subscription, timer} from 'rxjs';
import {ProductsService, QuoteOrderSampleService} from '../../apiservices';
import {ContactsService} from '../../apiservices/contacts.service';
import {Constants} from '../../constants';
import {PaginationModel, RequestParamModel, UserModel} from '../../models';
import {
  AlertService,
  AuthService,
  DebugLoggerService,
  HelperService,
  SubscribersService,
  WebSocketService
} from '../../services';
import {ConsoleSearchDialogComponent} from './console-search-dialog/console-search-dialog.component';
import {NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {TasksService} from "../../apiservices/tasks.service";
import { NotificationService } from '../../apiservices/notification.service';
import { QuoteService } from '../../apiservices/quote.service';
import {filter, switchMap, takeUntil} from "rxjs/operators";
import {NavigationEnd, Router} from '@angular/router';
import {environment} from "../../../../environments/environment";
import {ThemeService} from '../../services/theme.service';
import {EditProfileComponent} from '../edit-profile/edit-profile.component';
import {ChangePasswordComponent} from '../change-password/change-password.component';
import {lockPageScroll, unlockPageScroll} from '../../../shared/scroll-lock';
import {BsModalService} from 'ngx-bootstrap/modal';
import {ConfirmModalComponent} from '../confirm-modal/confirm-modal.component';

type HeaderMenu = 'customers' | 'sales' | 'fulfilment' | 'content' | 'settings' | 'profile';

@Component({
  standalone: false,
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css', '../../../app.component.css']
})
export class HeaderComponent implements OnInit, OnDestroy {

  /* ################### Variable Declaration Start ################### */
  public isCollapsed = true;
  /** Edit-profile / change-password dialogs (opened from the profile menu). */
  @ViewChild('editProfileModal') editProfileModal!: EditProfileComponent;
  @ViewChild('changePasswordModal') changePasswordModal!: ChangePasswordComponent;
  /** Open command-palette dialog, so ⌘K toggles instead of stacking dialogs. */
  private searchModalRef: NgbModalRef | null = null;
  username: any;
  user_detail = false;
  reset_password = false;
  isLoading = false;
 
  subscriptions = new Array<Subscription>();
  subscribeProfile = new Subscription();
  isOpen!: boolean;
  identity!: UserModel;
  /**
   * True once a profile carrying a NAME has landed. Drives the header's loading
   * skeleton: the profile lives in memory only (never localStorage), so every
   * reload starts with no name and the nameless BehaviorSubject seed must not
   * count as loaded. Reading `identity` alone was not enough — the seed sets it
   * to an empty UserModel, which is truthy.
   */
  get identityLoaded(): boolean {
    return !!(this.identity?.first_name || this.identity?.last_name);
  }
  /** Authoritative profile photo fetched from the server (login-user), used
      when the admin_user localStorage snapshot has none. */
  serverProfilePicture: any = null;
  /** Set when the stored avatar 404s, so the nav bar falls back to the initials. */
  avatarFailed = false;
  userForm: any;
  changePasswordForm: any;
  pendingContactCount = 0;
  sampleCount = 0;
  constants = Constants;
  /** Inline user-silhouette fallback avatar — self-contained, never 404s. */
  noImage = "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 36 36'><circle cx='18' cy='18' r='18' fill='%232B2B2F'/><circle cx='18' cy='14.5' r='6.2' fill='%23B9B9B9'/><path d='M6.5 30.5c1.6-5.2 6.1-8 11.5-8s9.9 2.8 11.5 8z' fill='%23B9B9B9'/></svg>";
  s3BucketImageURL!: any;
  navExpanded: boolean = false;
  userLogIn: boolean = true;
  pendingTaskCount = 0;
  totalStockAllocationProductCount = 0;
  isOpenNotificationSidebar: boolean = false;
  /**
   * Which header menu (a nav group, settings or profile) is open via an
   * explicit click/tap. Desktop also opens these on :hover (see the
   * `@media (hover: hover)` rule in header.component.css); on touch there is no
   * hover, so the tap-driven `.is-open` class is the only opener — which stops a
   * stray sticky-:hover (e.g. after closing the notification drawer, whose X sits
   * over the profile control) from opening a menu on its own.
   */
  openMenu: HeaderMenu | null = null;
  toggleSidebar: boolean = false;
  userProfileDetail: any
  isUnreadNotification:boolean = false;
  unReadNotificationCount=0
  /* ################### Variable Declaration End ################### */

  /** Subject for managing component subscriptions */
  private readonly destroy$ = new Subject<void>();

  isOrdersActive = false;
  isDespatchActive = false;

  /**
   * Mobile nav (burger) open state — shown under 1080px (matches console-v2).
   *
   * A getter/setter pair rather than a plain field so opening the drawer also
   * freezes the page behind the scrim; without it the background kept scrolling
   * under a full-height overlay. Every `mobileOpen = true/false` binding in the
   * template routes through the setter unchanged, so the markup is untouched.
   */
  private _mobileOpen = false;

  get mobileOpen(): boolean {
    return this._mobileOpen;
  }

  set mobileOpen(open: boolean) {
    this._mobileOpen = open;
    if (open) {
      // The burger drawer and the right-hand tap menus are mutually exclusive.
      this.openMenu = null;
      lockPageScroll('.m-menu', this);
    } else {
      unlockPageScroll(this);
    }
  }

  constructor(
    private changeDetectorRef: ChangeDetectorRef,
    private subscriberService: SubscribersService,
    private authenticationService: AuthService,
    public quoteServices: QuoteOrderSampleService,
    private contactService: ContactsService,
    private alertService: AlertService,
    private modalService: NgbModal,
    private taskService: TasksService,
    private subscribersService: SubscribersService,
    public helperServices: HelperService,
    private notificationService: NotificationService,
    private productService : ProductsService,
    private quoteService: QuoteService,
    private webSocketService: WebSocketService,
    private debugLogger: DebugLoggerService,
    private http: HttpClient,
    private router: Router,
    public themeService: ThemeService,
    private bsModalService: BsModalService,
  ) {
    subscriberService.changed_username.subscribe((value) => {
      this.username = value;
    });
    this.subscriberService.updatePendingAccountCount.subscribe((value) => {
      this.getPendingContactCount();
    });
    this.subscriberService.updateSampleOrderCount.subscribe((value) => {
      this.getSampleOrderCountOfOrderReceived();
    });
    this.subscriberService.updateTaskCount.subscribe((value: string) => {
      this.pendingTaskCount = +value;
    })
    this.subscriberService.updateUnReadNotificationCount.subscribe((value: string) => {
      this.getNotifications()
    })
    this.subscriberService.updateStockAllocationProduct
    .subscribe((value: any) => {
      if (value) { // Only act if it's a real value
        this.getStockAllocationByProductCount();
      }
    });

    subscriberService.userLogout.subscribe((value: boolean) => {
      if (value) {
        // Shell reset only. Clearing the auth state and redirecting to /login is
        // AuthService.endSession()'s job — the single authentication-failure flow — and it has
        // already run by the time this fires. This used to do its own teardown and finish with
        // `window.location.href = '/login'`; that document reload re-ran the bootstrap /me probe,
        // which on a partially-valid session (V3 cookie still good, Node API or service token
        // rejected) put the user back on /dashboard, whose widgets 401'd and reloaded again —
        // the infinite session-expired reload.
        this.userLogIn = false;
        this.closeProfileModals();
      }
    })

    this.subscribersService.notificationSidebarClick.subscribe((eventData: boolean) => {
      this.toggleNotificationSidebar(eventData);
    });

    this.subscribersService.isUnReadNotification.subscribe((eventData: boolean) => {
      this.isUnreadNotification = eventData;
    });
  }

  /************************************
   * Life cycle hooks start
   ************************************/

  ngOnInit() {
    this.updateActiveMenuState();
    // Fetch the authoritative avatar once — admin_user (localStorage) can lack a
    // profile_picture the server actually has, which left the header showing the
    // silhouette. serverProfilePicture takes priority in the profileAvatar getter.
    this.authenticationService.getLoginUserDetail().subscribe((u: any) => {
      if (u?.profile_picture && String(u.profile_picture).trim()) {
        this.serverProfilePicture = String(u.profile_picture).trim();
        // A new photo deserves a fresh attempt: `avatarFailed` latches on the FIRST
        // <img> error, so without this reset one bad URL (e.g. a stale absolute URL
        // published before this fetch) pinned the initials for the whole session even
        // once the working URL arrived.
        this.avatarFailed = false;
        this.changeDetectorRef.markForCheck();
      }
    }, () => { /* ignore — falls back to identity/admin_user */ });
    this.router.events.pipe(filter(e => e instanceof NavigationEnd)).subscribe(() => {
      this.updateActiveMenuState();
    });
     this.s3BucketImageURL = Constants.S3_PRODUCT_RESOURCE_IMAGE_KIT_URL + '/WEBSITE_ASSET_STAGING';
    this.getSampleOrderCountOfOrderReceived();
    this.getPendingContactCount();
    this.getPendingTaskCount();
    this.setupNotificationPolling();
    this.getStockAllocationByProductCount();
    this.setupWebSocketConnection();
    this.changeDetectorRef.markForCheck();
    this.subscribeProfile =
      this.subscriberService.profileModel.subscribe((data) => {
        if (data.first_name == undefined) {
          // This emission has no name — the empty BehaviorSubject seed or a
          // partial admin_user snapshot. Fetch the authoritative profile and let
          // ITS handler set `identity`. Do NOT fall through to `this.identity =
          // data` below: assigning the nameless payload blanks the header name
          // until the fetch returns (and leaves it blank if the fetch errors).
          // That was the "name sometimes disappears" bug.
          this.authenticationService.getLoginUserDetail().subscribe(
            (userModel: UserModel) => {
              if (userModel.profile_picture !== null) {
                // login-user returns a BARE filename → prefix with the
                // profile-picture bucket (same convention the note/reply avatars
                // use). Using the endpoint root (S3_PRODUCT_IMAGES) 404s to the
                // silhouette because the file lives under /profile-picture/.
                userModel.profile_picture = Constants.S3_USER_LOGO_IMAGE_KIT_URL + userModel.profile_picture;
                this.avatarFailed = false;   // new URL → retry the <img> (see ngOnInit)
              } else {
                delete userModel.profile_picture;
              }
              this.identity = userModel;
              this.patchUserForm();
              this.changeDetectorRef.markForCheck();
            }, (error: any) => {
              if (error.status == 422) {
                this.alertService.error(error, 'Error');
              }
              // 401 is deliberately not handled here: session expiry is owned by the single
              // authentication-failure flow (ErrorInterceptor -> AuthService.endSession), which
              // shows one message for the whole burst. A second toast per widget is noise.
            });
          return;
        }
        this.identity = data;
        // `loadProfile()` emits the bare profile_picture filename from
        // admin_user (localStorage), which the avatar template can't resolve on
        // its own → the image only appeared after a refresh (when
        // getLoginUserDetail set a full URL). Normalise here so a bare filename
        // is prefixed with the user-logo bucket immediately; already-absolute
        // URLs (from getLoginUserDetail / profile update) are left untouched.
        if (this.identity?.profile_picture && !/^https?:\/\//i.test(this.identity.profile_picture)) {
          this.identity.profile_picture = Constants.S3_USER_LOGO_IMAGE_KIT_URL + this.identity.profile_picture;
        }
        // A fresh photo published by the edit-profile dialog must beat the
        // one fetched at load, otherwise the header keeps showing the old
        // avatar (serverProfilePicture wins in the profileAvatar getter).
        if (this.identity?.profile_picture) {
          this.serverProfilePicture = this.identity.profile_picture;
          this.avatarFailed = false;   // new URL → retry the <img> (see ngOnInit)
        }
        this.changeDetectorRef.markForCheck();
        this.patchUserForm();
      })
  }

  private updateActiveMenuState(): void {
    const url = this.router.url;
    const fromDespatch = this.router.parseUrl(url).queryParams?.['from'] === 'despatch';
    this.isOrdersActive = url.startsWith('/orders') && !fromDespatch;
    this.isDespatchActive = url.startsWith('/despatch') || (url.startsWith('/orders') && fromDespatch);
  }

  /* ── Theme toggle (light / dark) ── */
  get isLight(): boolean {
    return this.themeService.theme === 'light';
  }

  toggleTheme(): void {
    this.themeService.toggle();
  }

  /* ── Grouped-nav active state ── */
  private urlStartsWithAny(paths: string[]): boolean {
    const url = this.router.url;
    return paths.some(p => url.startsWith(p));
  }

  get isCustomersActive(): boolean {
    return this.urlStartsWithAny(['/accounts', '/contacts']);
  }

  get isSalesActive(): boolean {
    return this.urlStartsWithAny(['/sample-requests', '/quotes', '/orders']);
  }

  get isFulfilmentActive(): boolean {
    return this.urlStartsWithAny(['/samples-fulfilment', '/despatch', '/stock-allocation']);
  }

  get isContentActive(): boolean {
    return this.urlStartsWithAny([
      '/blogs', '/projects', '/resource', '/faq', '/pebbl-feedback', '/pebbl-knowledge-feedback'
    ]);
  }

  ngOnDestroy(): void {
    this.subscribeProfile.unsubscribe();
    // A route change can tear the header down with the drawer still open; the
    // lock is global, so skipping this would leave the whole app unscrollable.
    unlockPageScroll(this);
  }

  /************************************
   * Life cycle hooks end
   ************************************/

  /************************************
   * Other functions start
   ************************************/

  toggleNotificationSidebar(eventData: boolean) {
    // Kept for the cross-app "close on navigate" signal (pages emit
    // emitNotificationSidebarToggle(false) on init). Simplified to a direct
    // assignment — the old inline subscribe to isNotificationSidebarOpen leaked
    // a new subscription on every call and never affected normal pages anyway.
    // On the dedicated /notifications page the inline list is shown, so the
    // drawer stays closed there.
    this.isOpenNotificationSidebar = window.location.pathname === '/notifications' ? false : eventData;
    this.changeDetectorRef.markForCheck();
  }

  resetForm() {
    this.user_detail = true;
    this.reset_password = false;
    this.userForm.reset();
    this.changePasswordForm.reset();
    // Re-populate from the current identity. Previously this called ngOnInit()
    // again, which re-subscribed to profileModel (leaking the prior
    // subscription and stacking duplicate handlers) and re-ran every count
    // fetch — repopulating the form is all that's needed here.
    this.patchUserForm();
  }

  /** Fill the edit-profile form from the current identity, guarding against a
   *  not-yet-built form or a nameless identity. */
  private patchUserForm(): void {
    if (!this.userForm || !this.identity) {
      return;
    }
    this.userForm.controls['first_name'].setValue(this.identity.first_name);
    this.userForm.controls['last_name'].setValue(this.identity.last_name);
    this.userForm.controls['email'].setValue(this.identity.email);
  }

  /** Menu → Log Out: ask first, and sign out only on Logout. */
  confirmLogout(): void {
    const modalRef = this.bsModalService.show(ConfirmModalComponent, {
      initialState: {
        title: Constants.LOGOUT_CONFIRMATION_TITLE,
        message: Constants.LOGOUT_CONFIRMATION_MESSAGE,
        confirmLabel: Constants.LOGOUT_CONFIRMATION_BUTTON,
      },
      class: 'delete-favourite-modal',
    });
    modalRef.content?.onClose.pipe(takeUntil(this.destroy$)).subscribe((confirmed: any) => {
      if (confirmed === true) {
        this.logout();
      }
    });
  }

  logout() {
    // Revoke the token server-side and clear the auth cookies, then hand over to the same
    // teardown the 401 path uses: it clears the client-side auth state and routes to /login once,
    // without reloading the document (a reload re-ran the bootstrap /me probe and could bounce
    // straight back into the app).
    this.authenticationService.logout().subscribe(() => {
      this.closeProfileModals();
      this.subscriberService.changed_username.next("");
      this.authenticationService.endSession();
    });
  }

  getSampleOrderCountOfOrderReceived() {
    const requestParamModel = new RequestParamModel();
    requestParamModel.addDefaultFilters('type', Constants.ORDER_TYPE_SAMPLE_SHORT, 'number');
    requestParamModel.addDefaultFilters('status.short_name', Constants.SAMPLE_ORDER_REQUESTED_SHORT, 'number');
    requestParamModel.fields = ['id']
    requestParamModel.pageSize = 1
    requestParamModel.addDefaultFilters('is_archive', this.constants.IS_ARCHIVE_NO, 'number');
    requestParamModel.addDefaultFilters('is_deleted',this.constants.IS_QUOTE_DELETED_FALSE, 'number');
    this.quoteService.getQuotes(requestParamModel).subscribe((dataList: PaginationModel<any>) => {
      this.isLoading = false;
      requestParamModel.update<any>(dataList);
      this.sampleCount = requestParamModel.totalCount
      this.changeDetectorRef.detectChanges();
    }, (error: HttpErrorResponse) => {
      this.isLoading = false;
    });
  }

  getPendingContactCount() {
    const requestParamModel = new RequestParamModel();
    // Exact status match — same filter the contacts list uses for its
    // "Pending Approval" tab badge. addDefaultFilter('status', 'N', 'string')
    // emitted a `[like]` filter which did not return the pending count, so the
    // header badge stayed hidden.
    requestParamModel.defaultFilter = `&filter[status]=${Constants.CONTACT_STATUS_PENDING_APPROVAL}`;
    requestParamModel.fields = ['contact_id'];
    requestParamModel.pageSize = 1
    this.contactService.getContactCout(requestParamModel).subscribe((dataList: PaginationModel<any>) => {
      this.isLoading = false;
      requestParamModel.update<any>(dataList);
      this.pendingContactCount = requestParamModel.totalCount
      this.changeDetectorRef.detectChanges()
    }, (error: HttpErrorResponse) => {
      this.isLoading = false;
    });
  }

  getPendingTaskCount() {
    const requestParamModel = new RequestParamModel();
    requestParamModel.addDefaultFilters('status', 'P', 'number');
    requestParamModel.pageSize = 1;
    this.taskService.getTasksList(requestParamModel).subscribe((dataList: PaginationModel<any>) => {
      this.isLoading = false;
      requestParamModel.update<any>(dataList);
      this.pendingTaskCount = requestParamModel.totalCount
    }, (error: HttpErrorResponse) => {
      this.isLoading = false;
    });
  }

  getStockAllocationByProductCount() {
    this.isLoading = true;
    const requestParamModel = new RequestParamModel();
     requestParamModel.addDefaultFilter('display_for', 'stock_allocation', 'number')
    requestParamModel.pageSize = 1;
    this.productService.getProduct(requestParamModel).subscribe((dataList: PaginationModel<any>) => {
      requestParamModel.update<any>(dataList);
      this.totalStockAllocationProductCount = requestParamModel.totalCount
     this.isLoading = false;
    }, (error: HttpErrorResponse) => {
      this.isLoading = false;
    });
  }

  /**
   * Resolved profile-photo URL without a size transform (or null → show the
   * silhouette fallback). Prefers `identity` but falls back to the `admin_user`
   * snapshot in localStorage, because on some loads `getLoginUserDetail`
   * resolves late (or returns a null photo) and wins the race, blanking
   * `identity.profile_picture` even though the logged-in user has a photo (the
   * note/reply avatars prove it). A bare filename is prefixed with the
   * /profile-picture/ bucket (the working convention); an already-absolute URL
   * is used as-is.
   */
  private get profilePictureBase(): string | null {
    // Priority: server-fetched photo (authoritative) → identity → admin_user
    // snapshot. admin_user can hold a null photo even when the server has one,
    // so the server fetch (see ngOnInit) is preferred.
    let pic: any = this.serverProfilePicture || this.identity?.profile_picture;
    if (!pic || !String(pic).trim()) {
      try {
        pic = JSON.parse(localStorage.getItem('admin_user') || '{}')?.profile_picture;
      } catch {
        pic = null;
      }
    }
    if (!pic || !String(pic).trim()) {
      return null;
    }
    pic = String(pic).trim();
    return /^https?:\/\//i.test(pic) ? pic : Constants.S3_USER_LOGO_IMAGE_KIT_URL + pic;
  }

  /** Nav-bar avatar (35×35). */
  get profileAvatar(): string | null {
    const base = this.profilePictureBase;
    return base ? base + Constants.IMAGE_SIZE_35_X_35 : null;
  }

  /** Edit-profile dialog avatar — rendered at 76px, so ask for a larger crop. */
  get profileAvatarLarge(): string | null {
    const base = this.profilePictureBase;
    return base ? base + Constants.IMAGE_SIZE_300 : null;
  }

  /**
   * First + last initial, matching the account/contact identity headers. Stands in for
   * the photo whenever there isn't one — including right after the user removes it.
   *
   * Empty (not '—') while the profile is still loading: the avatar renders before the
   * login-user fetch resolves, and a dash there read as the user's avatar changing —
   * "—" then the photo. An empty circle just fills in.
   */
  get profileInitials(): string {
    const first = (this.identity?.first_name || '').trim();
    const last = (this.identity?.last_name || '').trim();
    return ((first[0] || '') + (last[0] || '')).toUpperCase();
  }

  /**
   * The edit-profile dialog removed the photo. `serverProfilePicture` is the highest
   * priority source in profilePictureBase, so it has to be cleared here or the deleted
   * image would keep rendering in the nav bar until a reload.
   */
  onProfilePhotoRemoved(): void {
    this.serverProfilePicture = null;
    this.avatarFailed = false;
    if (this.identity) {
      this.identity.profile_picture = null as any;
    }
    // The admin_user snapshot is the last fallback — leave a stale photo there and it
    // would resurface on the next read.
    try {
      const snapshot = JSON.parse(localStorage.getItem('admin_user') || '{}');
      if (snapshot && typeof snapshot === 'object') {
        snapshot.profile_picture = null;
        localStorage.setItem('admin_user', JSON.stringify(snapshot));
      }
    } catch { /* nothing cached — nothing to clear */ }
    this.changeDetectorRef.detectChanges();
  }

  /* ── Profile menu → dialogs ── */
  /** Menu → open the edit-profile dialog, prefilled from the current user. */
  openEditProfile(): void {
    // Flush this view first: the click handler runs BEFORE change detection
    // pushes [identity]/[avatarUrl] into the dialog, so without this the form
    // would prefill from whatever the bindings held on the previous cycle.
    this.changeDetectorRef.detectChanges();
    this.editProfileModal.open();
  }

  /** Menu → open the change-password dialog. */
  openChangePassword(): void {
    this.changePasswordModal.open();
  }

  /** Close both profile dialogs (used on sign-out / forced logout). */
  closeProfileModals(): void {
    this.editProfileModal?.close();
    this.changePasswordModal?.close();
  }

  // for searching in  header
  openSearchDialog() {
    if (this.searchModalRef) {
      return;
    }

    const instance = this.modalService.open(ConsoleSearchDialogComponent, {
      centered: false,
      windowClass: 'console-search-window',
      backdropClass: 'console-search-backdrop',
      backdrop: true,
      keyboard: true,
    });
    this.searchModalRef = instance;

    instance.closed.subscribe(() => {
      this.searchModalRef = null;
    });
    instance.dismissed.subscribe(() => {
      this.searchModalRef = null;
    });
  }

  /**
   * ⌘K / Ctrl+K toggles the command palette. The toggle lives here — and only here —
   * because the header outlives the dialog, so one listener owns the open/closed state.
   */
  @HostListener('document:keydown', ['$event'])
  onSearchShortcut(event: KeyboardEvent): void {
    if ((event.metaKey || event.ctrlKey) && event.key.toLowerCase() === 'k') {
      event.preventDefault();
      if (this.searchModalRef) {
        this.searchModalRef.close();
      } else {
        this.openSearchDialog();
      }
    }
  }

  onClick() {
    this.navExpanded = true;
  }

  /**
   * Toggle a header menu on click/tap. `$event` stops here so the document:click
   * closer below does not immediately re-close the menu we are opening. Desktop
   * also opens these on hover; the click is the fallback for wherever hover does
   * not fire, and the only opener on touch.
   */
  toggleMenu(menu: HeaderMenu, event: Event): void {
    event.stopPropagation();
    event.preventDefault();
    this.openMenu = this.openMenu === menu ? null : menu;
    this.changeDetectorRef.markForCheck();
  }

  /** The pointer left a nav group: drop its click-opened state, so a pinned
      dropdown cannot stay up beside the one hover opens on the next group. */
  closeMenu(menu: HeaderMenu): void {
    if (this.openMenu === menu) {
      this.openMenu = null;
      this.changeDetectorRef.markForCheck();
    }
  }

  /** A tap/click anywhere else closes an open right-hand menu (the trigger stops
      its own propagation, so this only fires for genuine outside clicks and for
      menu-item clicks — both of which should dismiss the menu). */
  @HostListener('document:click')
  closeMenusOnOutsideClick(): void {
    if (this.openMenu) {
      this.openMenu = null;
      this.changeDetectorRef.markForCheck();
    }
  }

  openNotificationSidebar(event: Event) {
    event.preventDefault();
    event.stopPropagation();
    // Any open header menu should step aside for the drawer.
    this.openMenu = null;
    // Direct, immediate toggle. The previous Subject + setTimeout round-trip
    // left `isOpenNotificationSidebar` out of sync after the first open/close,
    // so the drawer wouldn't reopen. Owning the flag here makes every click
    // reliably open (or close) the drawer; the sidebar reports its own close
    // via the (closed) output below.
    this.isOpenNotificationSidebar = !this.isOpenNotificationSidebar;
    this.changeDetectorRef.markForCheck();
  }

  /** The drawer closed itself (× / scrim / navigation) — tear it down. */
  onNotificationSidebarClosed(): void {
    this.isOpenNotificationSidebar = false;
    this.changeDetectorRef.markForCheck();
  }

  private setupNotificationPolling(): void {
    let userProfile = JSON.stringify(this.authenticationService.getAdminUser());
    this.userProfileDetail = JSON.parse(userProfile);
    const requestParamModel = new RequestParamModel();
    requestParamModel.pageSize = '1';
    requestParamModel.fields = ['id'];
    requestParamModel.addDefaultFilter('to_user_id', this.userProfileDetail.id, 'number');
    requestParamModel.addDefaultFilter('status', 0, 'number');
    requestParamModel.sortChange('id', 'desc');

    // Poll every 30 seconds; timer(0, …) fires immediately on subscribe.
    timer(0, 30_000).pipe(
      takeUntil(this.destroy$),
      switchMap(() => this.notificationService.getUserNotifications(requestParamModel))
    ).subscribe({
      next: (dataList: any) => {
        const newCount = dataList.totalCount;
        if (newCount !== this.unReadNotificationCount) {
          this.unReadNotificationCount = newCount;
          // Notify the sidebar so it refreshes its list.
          this.subscriberService.updateUnreadNotification(newCount.toString());
        }
      },
      error: () => {}
    });
  }

  getNotifications(){
    const requestParamModel = new RequestParamModel();
    requestParamModel.pageSize = '1';
    let userProfile = JSON.stringify(this.authenticationService.getAdminUser());
    this.userProfileDetail = JSON.parse(userProfile);
    requestParamModel.fields = ['id'];
    requestParamModel.addDefaultFilter('to_user_id', this.userProfileDetail.id, 'number');
    requestParamModel.addDefaultFilter('status', 0, 'number');
    requestParamModel.sortChange('id', 'desc');
    this.notificationService.getUserNotifications(requestParamModel).subscribe((dataList) => {
        this.unReadNotificationCount = dataList.totalCount;
       }, (error: HttpErrorResponse) => {
    });
  }

  /**
   * Sets up WebSocket connection and event listeners for real-time updates.
   */
  private setupWebSocketConnection(): void {
    // Subscribe to quote events
    this.webSocketService.getSampleEvents()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (event) => {
          this.debugLogger.log('🔄 WebSocket sample request created event received - using handleGetQuoteDetail for toggle preservation:', event);
          // this.handleGetQuoteDetail();
          this.getSampleOrderCountOfOrderReceived();
        },
        error: (error) => {
          console.error('Error in sample request events subscription:', error);
        },
        complete: () => {
          this.debugLogger.log('Sample request events subscription completed');
        }
      });

    // Subscribe to connection state changes
    this.webSocketService.getConnectionState()
      .pipe(takeUntil(this.destroy$))
      .subscribe((state) => {
        this.debugLogger.log('QuoteView WebSocket connection state:', state);
        // Rejoin room on reconnection
        this.webSocketService.joinRoom('sample_request_created');
      });
  }

  /************************************
   * Other functions end
   ************************************/
}
